import en from '../../messages/shopify-guides/en.json';
import pl from '../../messages/shopify-guides/pl.json';
import uk from '../../messages/shopify-guides/uk.json';

const translations = { en, pl, uk };

export const getGuideUi = (locale = 'en') =>
  (translations[locale] || translations.en).ui;

export const getGuideToolUi = (locale = 'en') =>
  (translations[locale] || translations.en).tools;

export const guidePath = (slug, locale = 'en') =>
  locale === 'en'
    ? `/shopify-guides/${slug}`
    : `/${locale}/shopify-guides/${slug}`;

export const guideHubPath = (locale = 'en') =>
  locale === 'en' ? '/shopify-guides' : `/${locale}/shopify-guides`;
